const en = {
  home: "Application Overview",
  reports: "Reports",
  admin: "Administrator",
  name: "Name",
  email: "Email",
  phone: "Phone",
  comments: "Comments",
  type: "Type",
  description: "Description",
  count: "Count",
  print: "Print",
  add: (name) => `Add ${name}`,
  basicInfo: "Basic Info",
  sourceInfo: "Source Code Info",
  dockerImage: "Image Storage Info",
  applicationInfo: "Application Info",
  previous: "Previous",
  tag: "Tag",
  key: "Key",
  refresh: "Refresh",
  value: "Value",
  variables: "Variables",
  variable: "Variable",
  repository: "Repository",
  secrets: "Secrets",
  basics: "Basics",
  git: "Git",
  errorMsg:
    "We're experiencing a hiccup on our end. Please bear with us while we resolve the issue.",
  registrySecrets: "Registry Credentials",
  clusterStack: "Cluster Stack",
  clusterStore: "Cluster Store",
  server: "Server",
  separateEachElementInfoMsg:
    "Separate elements with commas or place each on a new line.",
  buildpack: "Build Pack",
  id: "ID",
  buildImage: "Build Image",
  build: "Build",
  buildNum: "Build Number",
  buildCounter: "Build Counter",
  latestBuildReason: "Build Reason",
  run: "Run",
  serviceAccount: "Service Account",
  runImage: "Run Image",
  revision: "Branch",
  category: "Category",
  answers: "Answers",
  answer: "Answer",
  edit: (name) => `Edit ${name}`,
  delete: (name) => `Delete ${name}`,
  open: (name) => `Open ${name}`,
  operation: "Operation",
  addNew: "Add New",
  import: "Import",
  export: "Export",
  transferData: "Transfer CSV Data",
  close: "Close",
  save: "Save",
  downloadFile: "Download File",
  downloadLogs: "Download Logs",
  users: "Users",
  user: "User",
  username: "Username",
  role: "Role",
  password: "Password",
  givenName: "Given name",
  familyName: "Family name",
  template: "Template",
  industries: "Industries",
  industry: "Industry",
  noResult: "No result",
  customized: "Customized",
  standard: "Standard",
  next: "Next",
  myProfile: "My Profile",
  logout: "Logout",
  steps: "Step by Step",
  all: "All",
  back: "Back",
  signin: "Sign in",
  contributor: "Contributor",
  readOnly: "Read-Only",
  userRights: "User Rights",
  continue2: "to continue to Clue2App",
  status: "Status",
  statusMsg: "Status message",
  completed: "completed",
  autosave: "Autosave",
  required: "Required",
  requiredMsg:
    "It looks like some required fields are missing. Please make sure to fill in all the necessary information before proceeding to the next step. All fields marked with an asterisk (*) are mandatory.",
  create: "Create",
  newCredentials: "New credentials",
  newRegistry: "New Registry",
  credentials: "Credentials",
  configurations: "Configurations",
  configs: "Variables",
  configsAndSecrets: "Shared environment variables",
  deleteMsgDetails:
    "Are you sure you want to delete this? This action cannot be undone. Please confirm if you wish to proceed.",
  view: "View",
  login: "Login",
  builds: "Builds",
  builds2: "Builds V2",
  logs: "Logs",
  instanceLogs: "Instance Logs",
  events: "Events",
  number: "Number",
  image: "Image",
  latestImage: "Latest Image",
  namespace: "Namespace",
  succeeded: "Succeeded",
  reviewPlusCreate: "Review + create",
  reviewPlusUpdate: "Review + update",
  builders: "Builders",
  images: "Images",
  serviceAccounts: "Service Accounts",
  gitSecrets: "Git Credentials",
  items: "Items",
  registries: "Image Storage",
  metrics: "Metrics",
  registry: "Registry",
  clusterStacks: "Cluster Stacks",
  clusterStores: "Cluster Stores",
  created: "Created",
  createdBy: "Created by",
  createdOn: "Created on",
  resourceVersion: "Resource Version",
  source: "Source",
  version: "Version",
  url: "URL",
  generation: "Generation",
  forceBuild: "Force Build",
  secretsCount: "secretsCount",
  imagePullSecretsCount: "imagePullSecretsCount",
  json: "Configuration Data",
  update: "Update",
  public: "Public",
  private: "Private",
  accessType: "Access Type",
  destroy: "Delete",
  confirm: "Confirm",
  extendedlWizard: "Extended Wizard",
  wizard: "Create a new application",
  group: "Group",
  groupName: "Group Name",
  appGroup: "Application Group",
  appGroupN: "Application Group Name",
  manageAppGroups: "Manage Application Groups",
  selectAppGroup: "Select Application Group",
  newAppGroup: "New Application Group",
  noAppGroup: "No Application Group",
  manageApplications: "Manage Applications",
  advanced: "Advanced",
  managePlatform: "Manage Platform",
  manage: "Manage",
  platformHostedRegistry: "Use platform's built-in storage",
  deployAutomatically: "Deploy Automatically",
  deployNewDb: "Deploy new database",
  database: "Database",
  service: "Service",
  servicesItem: "Runtime Services",
  deployment: "Deployment",
  containerPort: "Port your app runs on",
  port: "Port",
  host: "Host",
  project: "Project",
  appProject: "Application Project",
  projectN: "Project Name",
  manageProjects: "Manage Projects",
  selectProject: "Select Project",
  newProject: "New Project",
  noProject: "No Project",
  privateRepository: "Private Repository",
  gitRepos: "Git Repositories",
  application: "Application",
  cancel: "Cancel",
  cancelAndClose: "Cancel and Close",
  scaleTo0: "Sleep when idle",
  uploadJson: "Upload Json",
  uploadApplication: "Upload Application",
  userType: "User Type",
  accountSettings: "Account Settings",
  accountManagement: "Account Management",
  createdDate: "Created Date",
  token: "Token",
  discardChangesMsg: "Are you sure you want to discard your changes?",
  confirmDiscard: "Confirm Discard",
  closeDiscard: "Close Discard",
  discardChangesTitle: "Discard Changes",
  serviceCatalog: "Service Catalog",
  region: "Region",
  freeTier: "You're currently on the free tier, which limits access to certain features. Unlock this and other powerful features by upgrading to one of our higher plan!",
  locked: "Locked",
  lockedLabel: "Project locking allows you to protect Applications from accidental changes or deletions",
  kubernetesClusters: "Kubernetes Clusters",
  targetKubernetesCluster: "Target cluster",
  applicationSize: "Resource Size",
  cpuUsage: "CPU Usage",
  memoryUsage: "Memory Usage",
  trafficUsage: "Traffic Usage",
  domains: "Domains",
  domain: "Domain",
  subdomain: "Subdomain",
  fqdn: "FQDN",
  dnsMethod: "DNS Method",
  platformDomains: "Platform Domains",
  platformLimits: "Platform limits",
  customDomains: "Custom Domains",
  registerDomain: "Register Domain",
  assignDomain: "Assign Domain",
  unassign: "Unassign",
  nameservers: "Nameservers",
  assignments: "Assignments",
  appName: "Application",
  checkStatus: "Check Status",

  // Access section (SCK-470)
  access: "Access",
  accessMembers: "Members",
  accessInvitations: "Invitations",
  accessRoles: "Roles",
  accessSso: "SSO",
  accessAudit: "Audit log",
  inviteMember: "Invite to account",
  viewEffectivePermissions: "View effective permissions",
  copyUserId: "Copy user ID",
  comingSoon: "Coming soon",
  roleOwner: "Owner",
  roleAdmin: "Admin",
  roleDeveloper: "Developer",
  roleViewer: "Viewer",
  roleBilling: "Billing",
  roleSystem: "System",
};

export default en;
